export default () => localStorage.getItem('escenaRole') || '';



// WEBPACK FOOTER //
// ./src/utils/GetRole.js